import { render, staticRenderFns } from "./CardProductHover.vue?vue&type=template&id=f0a1486c&"
import script from "./CardProductHover.vue?vue&type=script&lang=js&"
export * from "./CardProductHover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports